// Single env surface — switch via .env files or build-time env vars,
// never code changes. Consumed by the feed client and Sentry init.
export const env = {
  zenoUrl: import.meta.env.VITE_ZENO_URL || 'https://zeno.devnet.mash.trade',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
};
